import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import CodeBlock from './CodeBlock';

const FormMetadataModal = ({ isExperimentalForm, formMetadata }) => {
  const {
    areAllFieldsOptional = false,
    experimentalTrialAttributes = {},
    formAttributesConfig = {},
  } = formMetadata || {};
  const [isVisible, setIsVisible] = useState(false);
  const [isHover, setIsHover] = useState(false);

  if (!isExperimentalForm) return null;

  const onCancel = () => setIsVisible(false);
  const onClick = () => setIsVisible(true);

  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const buttonStyle = {
    borderColor: '#6c757d',
    backgroundColor: isHover ? '#6c757d' : 'white',
    color: isHover ? 'white' : '#6c757d',
  };
  return (
    <>
      <button
        id="experimental-data-button"
        type="button"
        className="btn btn-sm"
        style={buttonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={onClick}
      >
        View Experimental Data
      </button>
      {isVisible ? (
        <Modal>
          <Modal.Header onCancel={onCancel}>
            <h5 id="modal-title">Experimental Data</h5>
          </Modal.Header>
          <Modal.Body>
            <p
              id="all-optional-selction"
              className="font-weight-bold"
            >
              Are all fields optional:
              <span className="font-weight-normal"> { areAllFieldsOptional ? 'Yes' : 'No' }</span>
            </p>
            <p id="trial-label" className="font-weight-bold">Experimental Trial Attributes</p>
            <CodeBlock id="trial-attrs" codeSnippet={experimentalTrialAttributes} />
            <p id="config-label" className="font-weight-bold">Attributes Config Data</p>
            <CodeBlock id="attrs-config" codeSnippet={formAttributesConfig} />
          </Modal.Body>
          <Modal.Footer>
            <button id="bottom-close-button" type="button" className="btn btn-secondary" onClick={onCancel}>Close</button>
          </Modal.Footer>
        </Modal>
      ) : null}
    </>

  );
};
FormMetadataModal.propTypes = {
  isExperimentalForm: PropTypes.bool,
  formMetadata: PropTypes.shape({
    isFormJSONEditable: PropTypes.bool,
    areAllFieldsOptional: PropTypes.bool,
    experimentalTrialAttributes: PropTypes.object,
    formAttributesConfig: PropTypes.object,
  }),
};

export default FormMetadataModal;
